/**
 * § 20 Abs. 1 HOAI, https://www.gesetze-im-internet.de/hoai_2013/__20.html
 * Fläche in Hektar; 3 Honorarzonen: geringe Anforderungen, durchschnittliche Anforderungen, hohe Anforderungen.
 */
export const HOAI_TABLE_FNP = [
    [1000, 70439, 85269, 85269, 100098, 100098, 114927],
    [1250, 78957, 95579, 95579, 112202, 112202, 128824],
    [1500, 86492, 104700, 104700, 122909, 122909, 141118],
    [1750, 93260, 112894, 112894, 132527, 132527, 152161],
    [2000, 99407, 120334, 120334, 141262, 141262, 162190],
    [2500, 111311, 134745, 134745, 158178, 158178, 181612],
    [3000, 121868, 147525, 147525, 173181, 173181, 198838],
    [3500, 131387, 159047, 159047, 186707, 186707, 214367],
    [4000, 140069, 169557, 169557, 199045, 199045, 228533],
    [5000, 155461, 188190, 188190, 220918, 220918, 253647],
    [6000, 168813, 204352, 204352, 239892, 239892, 275431],
    [7000, 180589, 218607, 218607, 256626, 256626, 294645],
    [8000, 191097, 231328, 231328, 271559, 271559, 311790],
    [9000, 200556, 242779, 242779, 285001, 285001, 327224],
    [10000, 209126, 253153, 253153, 297179, 297179, 341206],
    [11000, 216893, 262555, 262555, 308217, 308217, 353878],
    [12000, 223912, 271052, 271052, 318191, 318191, 365331],
    [13000, 230331, 278822, 278822, 327313, 327313, 375804],
    [14000, 236214, 285944, 285944, 335673, 335673, 385402],
    [15000, 241614, 292480, 292480, 343346, 343346, 394213],
];
/**
 * § 21 Abs. 1 HOAI, https://www.gesetze-im-internet.de/hoai_2013/__21.html
 * Fläche in Hektar; 3 Honorarzonen: geringe Anforderungen, durchschnittliche Anforderungen, hohe Anforderungen.
 * Im Verordnungstext so enthalten (nicht korrigiert): Spalte Zone I von: 0,5 -> 1 nicht steigend (5000 -> 5000).
 */
export const HOAI_TABLE_BPLAN = [
    [0.5, 5000, 5335, 5335, 7838, 7838, 10341],
    [1, 5000, 8799, 8799, 12926, 12926, 17054],
    [2, 7699, 14502, 14502, 21305, 21305, 28109],
    [3, 10306, 19413, 19413, 28521, 28521, 37628],
    [4, 12669, 23866, 23866, 35062, 35062, 46258],
    [5, 14864, 28000, 28000, 41135, 41135, 54271],
    [6, 16931, 31893, 31893, 46856, 46856, 61818],
    [7, 18896, 35595, 35595, 52294, 52294, 68992],
    [8, 20776, 39137, 39137, 57497, 57497, 75857],
    [9, 22584, 42542, 42542, 62501, 62501, 82459],
    [10, 24330, 45830, 45830, 67331, 67331, 88831],
    [15, 32325, 60892, 60892, 89458, 89458, 118025],
    [20, 39427, 74270, 74270, 109113, 109113, 143956],
    [25, 46385, 87376, 87376, 128366, 128366, 169357],
    [30, 52975, 99791, 99791, 146606, 146606, 193422],
    [40, 65342, 123086, 123086, 180830, 180830, 238574],
    [50, 76901, 144860, 144860, 212819, 212819, 280778],
    [60, 87599, 165012, 165012, 242425, 242425, 319838],
    [80, 107471, 202445, 202445, 297419, 297419, 392393],
    [100, 125791, 236955, 236955, 348119, 348119, 459282],
];
/**
 * § 28 Abs. 1 HOAI, https://www.gesetze-im-internet.de/hoai_2013/__28.html
 * Fläche in Hektar; 3 Honorarzonen: geringe Anforderungen, durchschnittliche Anforderungen, hohe Anforderungen.
 */
export const HOAI_TABLE_LANDSCHAFTSPLAN = [
    [1000, 23403, 27963, 27963, 32826, 32826, 37385],
    [1250, 26560, 31735, 31735, 37254, 37254, 42428],
    [1500, 29445, 35182, 35182, 41300, 41300, 47036],
    [1750, 32119, 38375, 38375, 45049, 45049, 51306],
    [2000, 34620, 41364, 41364, 48558, 48558, 55302],
    [2500, 39212, 46851, 46851, 54999, 54999, 62638],
    [3000, 43374, 51824, 51824, 60837, 60837, 69286],
    [3500, 47199, 56393, 56393, 66201, 66201, 75396],
    [4000, 50747, 60633, 60633, 71178, 71178, 81064],
    [5000, 57180, 68319, 68319, 80200, 80200, 91339],
    [6000, 63562, 75944, 75944, 89151, 89151, 101533],
    [7000, 69505, 83045, 83045, 97487, 97487, 111027],
    [8000, 75095, 89724, 89724, 105329, 105329, 119958],
    [9000, 80394, 96055, 96055, 112761, 112761, 128422],
    [10000, 85445, 102090, 102090, 119845, 119845, 136490],
    [11000, 89986, 107516, 107516, 126214, 126214, 143744],
    [12000, 94309, 112681, 112681, 132278, 132278, 150650],
    [13000, 98438, 117615, 117615, 138069, 138069, 157246],
    [14000, 102392, 122339, 122339, 143615, 143615, 163562],
    [15000, 106187, 126873, 126873, 148938, 148938, 169623],
];
/**
 * § 29 Abs. 1 HOAI, https://www.gesetze-im-internet.de/hoai_2013/__29.html
 * Fläche in Hektar; 3 Honorarzonen: geringe Anforderungen, durchschnittliche Anforderungen, hohe Anforderungen.
 */
export const HOAI_TABLE_GRUENORDNUNGSPLAN = [
    [1.5, 5219, 6067, 6067, 6980, 6980, 7828],
    [2, 6008, 6985, 6985, 8036, 8036, 9013],
    [3, 7450, 8661, 8661, 9965, 9965, 11175],
    [4, 8770, 10195, 10195, 11730, 11730, 13155],
    [5, 10006, 11632, 11632, 13383, 13383, 15009],
    [10, 15445, 17955, 17955, 20658, 20658, 23167],
    [15, 20183, 23462, 23462, 26994, 26994, 30274],
    [20, 24513, 28496, 28496, 32785, 32785, 36769],
    [25, 28560, 33201, 33201, 38199, 38199, 42840],
    [30, 32394, 37658, 37658, 43326, 43326, 48590],
    [40, 39580, 46011, 46011, 52938, 52938, 59370],
    [50, 46282, 53803, 53803, 61902, 61902, 69423],
    [75, 61579, 71586, 71586, 82362, 82362, 92369],
    [100, 75430, 87687, 87687, 100887, 100887, 113145],
    [125, 88255, 102597, 102597, 118042, 118042, 132383],
    [150, 100288, 116585, 116585, 134136, 134136, 150433],
    [175, 111675, 129822, 129822, 149366, 149366, 167513],
    [200, 122516, 142425, 142425, 163866, 163866, 183774],
    [225, 133555, 155258, 155258, 178630, 178630, 200333],
    [250, 144284, 167730, 167730, 192980, 192980, 216426],
];
/**
 * § 30 Abs. 1 HOAI, https://www.gesetze-im-internet.de/hoai_2013/__30.html
 * Fläche in Hektar; 3 Honorarzonen: geringe Anforderungen, durchschnittliche Anforderungen, hohe Anforderungen.
 */
export const HOAI_TABLE_LANDSCHAFTSRAHMENPLAN = [
    [5000, 61880, 71935, 71935, 82764, 82764, 92820],
    [6000, 67933, 78973, 78973, 90861, 90861, 101900],
    [7000, 73473, 85413, 85413, 98270, 98270, 110210],
    [8000, 78600, 91373, 91373, 105128, 105128, 117901],
    [9000, 83385, 96936, 96936, 111528, 111528, 125078],
    [10000, 87880, 102161, 102161, 117540, 117540, 131820],
    [12000, 96149, 111773, 111773, 128599, 128599, 144223],
    [14000, 103631, 120471, 120471, 138607, 138607, 155447],
    [16000, 110477, 128430, 128430, 147763, 147763, 165716],
    [18000, 116791, 135769, 135769, 156208, 156208, 175186],
    [20000, 122649, 142580, 142580, 164043, 164043, 183974],
    [25000, 138047, 160480, 160480, 184638, 184638, 207070],
    [30000, 152052, 176761, 176761, 203370, 203370, 228078],
    [40000, 177097, 205875, 205875, 236867, 236867, 265645],
    [50000, 199330, 231721, 231721, 266604, 266604, 298995],
    [60000, 219553, 255230, 255230, 293652, 293652, 329329],
    [70000, 238243, 276958, 276958, 318650, 318650, 357365],
    [80000, 253946, 295212, 295212, 339652, 339652, 380918],
    [90000, 268420, 312038, 312038, 359011, 359011, 402630],
    [100000, 281843, 327643, 327643, 376965, 376965, 422765],
];
/**
 * § 31 Abs. 1 HOAI, https://www.gesetze-im-internet.de/hoai_2013/__31.html
 * Fläche in Hektar; 3 Honorarzonen: geringe Anforderungen, durchschnittliche Anforderungen, hohe Anforderungen.
 */
export const HOAI_TABLE_LBP = [
    [6, 5324, 6189, 6189, 7121, 7121, 7986],
    [8, 6130, 7126, 7126, 8199, 8199, 9195],
    [12, 7600, 8836, 8836, 10166, 10166, 11401],
    [16, 8947, 10401, 10401, 11966, 11966, 13420],
    [20, 10207, 11866, 11866, 13652, 13652, 15311],
    [40, 15755, 18315, 18315, 21072, 21072, 23632],
    [100, 29126, 33859, 33859, 38956, 38956, 43689],
    [200, 47180, 54846, 54846, 63103, 63103, 70769],
    [300, 62748, 72944, 72944, 83925, 83925, 94121],
    [400, 76829, 89314, 89314, 102759, 102759, 115244],
    [500, 89855, 104456, 104456, 120181, 120181, 134782],
    [600, 102062, 118647, 118647, 136508, 136508, 153093],
    [700, 113602, 132062, 132062, 151942, 151942, 170402],
    [800, 124575, 144819, 144819, 166620, 166620, 186863],
    [1200, 167729, 194985, 194985, 224338, 224338, 251594],
    [1600, 207279, 240961, 240961, 277235, 277235, 310918],
    [2000, 244349, 284056, 284056, 326817, 326817, 366524],
    [2400, 279559, 324987, 324987, 373910, 373910, 419338],
    [3200, 343814, 399683, 399683, 459851, 459851, 515720],
    [4000, 400847, 465985, 465985, 536133, 536133, 601270],
];
/**
 * § 32 Abs. 1 HOAI, https://www.gesetze-im-internet.de/hoai_2013/__32.html
 * Fläche in Hektar; 3 Honorarzonen: geringe Anforderungen, durchschnittliche Anforderungen, hohe Anforderungen.
 */
export const HOAI_TABLE_PEP = [
    [5, 3852, 7704, 7704, 11556, 11556, 15408],
    [10, 4802, 9603, 9603, 14405, 14405, 19207],
    [15, 5481, 10963, 10963, 16444, 16444, 21925],
    [20, 6029, 12058, 12058, 18087, 18087, 24116],
    [30, 6906, 13813, 13813, 20719, 20719, 27626],
    [40, 7612, 15225, 15225, 22837, 22837, 30450],
    [50, 8213, 16425, 16425, 24638, 24638, 32851],
    [75, 9433, 18866, 18866, 28298, 28298, 37731],
    [100, 10408, 20816, 20816, 31224, 31224, 41633],
    [150, 11949, 23899, 23899, 35848, 35848, 47798],
    [200, 13165, 26330, 26330, 39495, 39495, 52660],
    [300, 15318, 30636, 30636, 45954, 45954, 61272],
    [400, 17087, 34174, 34174, 51262, 51262, 68349],
    [500, 18621, 37242, 37242, 55863, 55863, 74484],
    [750, 21833, 43666, 43666, 65500, 65500, 87333],
    [1000, 24507, 49014, 49014, 73522, 73522, 98029],
    [1500, 28966, 57932, 57932, 86898, 86898, 115864],
    [2500, 36065, 72131, 72131, 108196, 108196, 144261],
    [5000, 49288, 98575, 98575, 147863, 147863, 197150],
    [10000, 69015, 138029, 138029, 207044, 207044, 276058],
];
/**
 * § 35 Abs. 1 HOAI, https://www.gesetze-im-internet.de/hoai_2013/__35.html
 * Anrechenbare Kosten in Euro; 5 Honorarzonen: sehr geringe Anforderungen, geringe Anforderungen, durchschnittliche Anforderungen, hohe Anforderungen, sehr hohe Anforderungen.
 */
export const HOAI_TABLE_GEBAEUDE = [
    [25000, 3120, 3657, 3657, 4339, 4339, 5412, 5412, 6094, 6094, 6631],
    [35000, 4217, 4942, 4942, 5865, 5865, 7315, 7315, 8237, 8237, 8962],
    [50000, 5804, 6801, 6801, 8071, 8071, 10066, 10066, 11336, 11336, 12333],
    [75000, 8342, 9776, 9776, 11601, 11601, 14469, 14469, 16293, 16293, 17727],
    [100000, 10790, 12644, 12644, 15005, 15005, 18713, 18713, 21074, 21074, 22928],
    [150000, 15500, 18164, 18164, 21555, 21555, 26883, 26883, 30274, 30274, 32938],
    [200000, 20037, 23480, 23480, 27863, 27863, 34751, 34751, 39134, 39134, 42578],
    [300000, 28750, 33692, 33692, 39981, 39981, 49864, 49864, 56153, 56153, 61095],
    [500000, 45232, 53006, 53006, 62900, 62900, 78449, 78449, 88343, 88343, 96118],
    [750000, 64666, 75781, 75781, 89927, 89927, 112156, 112156, 126301, 126301, 137416],
    [1000000, 83182, 97479, 97479, 115675, 115675, 144268, 144268, 162464, 162464, 176761],
    [1500000, 119307, 139813, 139813, 165911, 165911, 206923, 206923, 233022, 233022, 253527],
    [2000000, 153965, 180428, 180428, 214108, 214108, 267034, 267034, 300714, 300714, 327177],
    [3000000, 220161, 258002, 258002, 306162, 306162, 381843, 381843, 430003, 430003, 467843],
    [5000000, 343879, 402984, 402984, 478207, 478207, 596416, 596416, 671640, 671640, 730744],
    [7500000, 493923, 578816, 578816, 686862, 686862, 856648, 856648, 964694, 964694, 1049587],
    [10000000, 638277, 747981, 747981, 887604, 887604, 1107012, 1107012, 1246635, 1246635, 1356339],
    [15000000, 915129, 1072416, 1072416, 1272601, 1272601, 1587176, 1587176, 1787360, 1787360, 1944648],
    [20000000, 1180414, 1383298, 1383298, 1641513, 1641513, 2047281, 2047281, 2305496, 2305496, 2508380],
    [25000000, 1436874, 1683837, 1683837, 1998153, 1998153, 2492079, 2492079, 2806395, 2806395, 3053358],
];
/**
 * § 40 Abs. 1 HOAI, https://www.gesetze-im-internet.de/hoai_2013/__40.html
 * Anrechenbare Kosten in Euro; 5 Honorarzonen: sehr geringe Anforderungen, geringe Anforderungen, durchschnittliche Anforderungen, hohe Anforderungen, sehr hohe Anforderungen.
 */
export const HOAI_TABLE_FREIANLAGEN = [
    [20000, 3643, 4348, 4348, 5229, 5229, 6521, 6521, 7403, 7403, 8108],
    [25000, 4406, 5259, 5259, 6325, 6325, 7888, 7888, 8954, 8954, 9807],
    [30000, 5147, 6143, 6143, 7388, 7388, 9215, 9215, 10460, 10460, 11456],
    [35000, 5870, 7006, 7006, 8426, 8426, 10508, 10508, 11928, 11928, 13064],
    [40000, 6577, 7850, 7850, 9441, 9441, 11774, 11774, 13365, 13365, 14638],
    [50000, 7953, 9492, 9492, 11416, 11416, 14238, 14238, 16162, 16162, 17701],
    [60000, 9287, 11085, 11085, 13332, 13332, 16627, 16627, 18874, 18874, 20672],
    [75000, 11227, 13400, 13400, 16116, 16116, 20100, 20100, 22816, 22816, 24989],
    [100000, 14332, 17106, 17106, 20574, 20574, 25659, 25659, 29127, 29127, 31901],
    [125000, 17315, 20666, 20666, 24855, 24855, 30999, 30999, 35188, 35188, 38539],
    [150000, 20201, 24111, 24111, 28998, 28998, 36166, 36166, 41053, 41053, 44963],
    [200000, 25746, 30729, 30729, 36958, 36958, 46094, 46094, 52323, 52323, 57306],
    [250000, 31053, 37063, 37063, 44576, 44576, 55594, 55594, 63107, 63107, 69117],
    [350000, 41147, 49111, 49111, 59066, 59066, 73667, 73667, 83622, 83622, 91586],
    [500000, 55300, 66004, 66004, 79383, 79383, 99006, 99006, 112385, 112385, 123088],
    [650000, 69114, 82491, 82491, 99212, 99212, 123736, 123736, 140457, 140457, 153834],
    [800000, 82430, 98384, 98384, 118326, 118326, 147576, 147576, 167518, 167518, 183472],
    [1000000, 99578, 118851, 118851, 142942, 142942, 178276, 178276, 202368, 202368, 221641],
    [1250000, 120238, 143510, 143510, 172600, 172600, 215265, 215265, 244355, 244355, 267627],
    [1500000, 140204, 167340, 167340, 201261, 201261, 251011, 251011, 284931, 284931, 312067],
];
/**
 * § 44 Abs. 1 HOAI, https://www.gesetze-im-internet.de/hoai_2013/__44.html
 * Anrechenbare Kosten in Euro; 5 Honorarzonen: sehr geringe Anforderungen, geringe Anforderungen, durchschnittliche Anforderungen, hohe Anforderungen, sehr hohe Anforderungen.
 */
export const HOAI_TABLE_INGENIEURBAUWERKE = [
    [25000, 3449, 4109, 4109, 4768, 4768, 5428, 5428, 6036, 6036, 6696],
    [35000, 4475, 5331, 5331, 6186, 6186, 7042, 7042, 7831, 7831, 8687],
    [50000, 5897, 7024, 7024, 8152, 8152, 9279, 9279, 10320, 10320, 11447],
    [75000, 8069, 9611, 9611, 11154, 11154, 12697, 12697, 14121, 14121, 15663],
    [100000, 10079, 12005, 12005, 13932, 13932, 15859, 15859, 17637, 17637, 19564],
    [150000, 13786, 16422, 16422, 19058, 19058, 21693, 21693, 24126, 24126, 26762],
    [200000, 17215, 20506, 20506, 23797, 23797, 27088, 27088, 30126, 30126, 33417],
    [300000, 23534, 28033, 28033, 32532, 32532, 37031, 37031, 41185, 41185, 45684],
    [500000, 34865, 41530, 41530, 48195, 48195, 54861, 54861, 61013, 61013, 67679],
    [750000, 47576, 56672, 56672, 65767, 65767, 74863, 74863, 83258, 83258, 92354],
    [1000000, 59264, 70594, 70594, 81924, 81924, 93254, 93254, 103712, 103712, 115042],
    [1500000, 80998, 96482, 96482, 111967, 111967, 127452, 127452, 141746, 141746, 157230],
    [2000000, 101054, 120373, 120373, 139692, 139692, 159011, 159011, 176844, 176844, 196163],
    [3000000, 137907, 164272, 164272, 190636, 190636, 217001, 217001, 241338, 241338, 267702],
    [5000000, 203584, 242504, 242504, 281425, 281425, 320345, 320345, 356272, 356272, 395192],
    [7500000, 278415, 331642, 331642, 384868, 384868, 438095, 438095, 487227, 487227, 540453],
    [10000000, 347568, 414014, 414014, 480461, 480461, 546908, 546908, 608244, 608244, 674690],
    [15000000, 474901, 565691, 565691, 656480, 656480, 747270, 747270, 831076, 831076, 921866],
    [20000000, 592324, 705563, 705563, 818801, 818801, 932040, 932040, 1036568, 1036568, 1149806],
    [25000000, 702770, 837123, 837123, 971476, 971476, 1105829, 1105829, 1229848, 1229848, 1364201],
];
/**
 * § 48 Abs. 1 HOAI, https://www.gesetze-im-internet.de/hoai_2013/__48.html
 * Anrechenbare Kosten in Euro; 5 Honorarzonen: sehr geringe Anforderungen, geringe Anforderungen, durchschnittliche Anforderungen, hohe Anforderungen, sehr hohe Anforderungen.
 */
export const HOAI_TABLE_VERKEHRSANLAGEN = [
    [25000, 3882, 4624, 4624, 5366, 5366, 6108, 6108, 6793, 6793, 7535],
    [35000, 4981, 5933, 5933, 6885, 6885, 7837, 7837, 8716, 8716, 9668],
    [50000, 6487, 7727, 7727, 8967, 8967, 10207, 10207, 11352, 11352, 12592],
    [75000, 8759, 10434, 10434, 12108, 12108, 13783, 13783, 15328, 15328, 17003],
    [100000, 10839, 12911, 12911, 14983, 14983, 17056, 17056, 18968, 18968, 21041],
    [150000, 14634, 17432, 17432, 20229, 20229, 23027, 23027, 25610, 25610, 28407],
    [200000, 18106, 21567, 21567, 25029, 25029, 28490, 28490, 31685, 31685, 35147],
    [300000, 24435, 29106, 29106, 33778, 33778, 38449, 38449, 42761, 42761, 47433],
    [500000, 35622, 42433, 42433, 49243, 49243, 56053, 56053, 62339, 62339, 69149],
    [750000, 48001, 57178, 57178, 66355, 66355, 75532, 75532, 84002, 84002, 93179],
    [1000000, 59267, 70597, 70597, 81928, 81928, 93258, 93258, 103717, 103717, 115047],
    [1500000, 80009, 95305, 95305, 110600, 110600, 125896, 125896, 140015, 140015, 155311],
    [2000000, 98962, 117881, 117881, 136800, 136800, 155719, 155719, 173183, 173183, 192102],
    [3000000, 133441, 158951, 158951, 184462, 184462, 209973, 209973, 233521, 233521, 259032],
    [5000000, 194094, 231200, 231200, 268306, 268306, 305412, 305412, 339664, 339664, 376770],
    [7500000, 262407, 312573, 312573, 362739, 362739, 412905, 412905, 459212, 459212, 509378],
    [10000000, 324978, 387107, 387107, 449235, 449235, 511363, 511363, 568712, 568712, 630840],
    [15000000, 439179, 523140, 523140, 607101, 607101, 691062, 691062, 768564, 768564, 852525],
    [20000000, 543619, 647546, 647546, 751473, 751473, 855401, 855401, 951333, 951333, 1055260],
    [25000000, 641265, 763860, 763860, 886454, 886454, 1009049, 1009049, 1122213, 1122213, 1244808],
];
/**
 * § 52 Abs. 1 HOAI, https://www.gesetze-im-internet.de/hoai_2013/__52.html
 * Anrechenbare Kosten in Euro; 5 Honorarzonen: sehr geringe Anforderungen, geringe Anforderungen, durchschnittliche Anforderungen, hohe Anforderungen, sehr hohe Anforderungen.
 */
export const HOAI_TABLE_TRAGWERK = [
    [10000, 1461, 1624, 1624, 2064, 2064, 2575, 2575, 3015, 3015, 3178],
    [15000, 2011, 2234, 2234, 2841, 2841, 3543, 3543, 4149, 4149, 4373],
    [25000, 3006, 3340, 3340, 4247, 4247, 5296, 5296, 6203, 6203, 6537],
    [50000, 5187, 5763, 5763, 7327, 7327, 9139, 9139, 10703, 10703, 11279],
    [75000, 7135, 7928, 7928, 10080, 10080, 12572, 12572, 14724, 14724, 15517],
    [100000, 8946, 9940, 9940, 12639, 12639, 15763, 15763, 18461, 18461, 19455],
    [150000, 12303, 13670, 13670, 17380, 17380, 21677, 21677, 25387, 25387, 26754],
    [250000, 18370, 20411, 20411, 25951, 25951, 32365, 32365, 37906, 37906, 39947],
    [350000, 23909, 26565, 26565, 33776, 33776, 42125, 42125, 49335, 49335, 51992],
    [500000, 31594, 35105, 35105, 44633, 44633, 55666, 55666, 65194, 65194, 68705],
    [750000, 43463, 48293, 48293, 61401, 61401, 76578, 76578, 89686, 89686, 94515],
    [1000000, 54495, 60550, 60550, 76984, 76984, 96014, 96014, 112449, 112449, 118504],
    [1250000, 64940, 72155, 72155, 91740, 91740, 114418, 114418, 134003, 134003, 141218],
    [1500000, 74938, 83265, 83265, 105865, 105865, 132034, 132034, 154635, 154635, 162961],
    [2000000, 93923, 104358, 104358, 132684, 132684, 165483, 165483, 193808, 193808, 204244],
    [3000000, 129059, 143398, 143398, 182321, 182321, 227389, 227389, 266311, 266311, 280651],
    [5000000, 192384, 213760, 213760, 271781, 271781, 338962, 338962, 396983, 396983, 418359],
    [7500000, 264487, 293874, 293874, 373640, 373640, 466001, 466001, 545767, 545767, 575154],
    [10000000, 331398, 368220, 368220, 468166, 468166, 583892, 583892, 683838, 683838, 720660],
    [15000000, 455117, 505686, 505686, 642943, 642943, 801873, 801873, 939131, 939131, 989699],
];
/**
 * § 56 Abs. 1 HOAI, https://www.gesetze-im-internet.de/hoai_2013/__56.html
 * Anrechenbare Kosten in Euro; 3 Honorarzonen: geringe Anforderungen, durchschnittliche Anforderungen, hohe Anforderungen.
 */
export const HOAI_TABLE_TGA = [
    [5000, 2132, 2547, 2547, 2990, 2990, 3405],
    [10000, 3689, 4408, 4408, 5174, 5174, 5893],
    [15000, 5084, 6075, 6075, 7131, 7131, 8122],
    [25000, 7615, 9098, 9098, 10681, 10681, 12164],
    [35000, 9934, 11869, 11869, 13934, 13934, 15869],
    [50000, 13165, 15729, 15729, 18465, 18465, 21029],
    [75000, 18122, 21652, 21652, 25418, 25418, 28948],
    [100000, 22723, 27150, 27150, 31872, 31872, 36299],
    [150000, 31228, 37311, 37311, 43800, 43800, 49883],
    [250000, 46640, 55726, 55726, 65418, 65418, 74504],
    [500000, 80684, 96402, 96402, 113168, 113168, 128886],
    [750000, 111105, 132749, 132749, 155836, 155836, 177480],
    [1000000, 139347, 166493, 166493, 195448, 195448, 222594],
    [1250000, 166043, 198389, 198389, 232891, 232891, 265237],
    [1500000, 191545, 228859, 228859, 268660, 268660, 305974],
    [2000000, 239792, 286504, 286504, 336331, 336331, 383044],
    [2500000, 285649, 341295, 341295, 400650, 400650, 456296],
    [3000000, 329420, 393593, 393593, 462044, 462044, 526217],
    [3500000, 371491, 443859, 443859, 521052, 521052, 593420],
    [4000000, 412126, 492410, 492410, 578046, 578046, 658331],
];
//# sourceMappingURL=hoai-tables.js.map